import Model from "./Model";
import Designer from "./Designer";
import User from "./User";

class AsyncProcess extends Model {
  constructor(options) {
    super();
    (this as any).user = d => {
      return new User(d.data);
    };
    (this as any).details = d => {
      if (!d) {
        return {
          data: null,
          printed: false
        };
      }
      return JSON.parse(d);
    };
    this.bind(options);
  }
}

export default AsyncProcess;
